module.exports = {"410322100":"城关镇","410322101":"会盟镇","410322102":"平乐镇","410322103":"送庄镇","410322104":"白鹤镇","410322105":"朝阳镇","410322106":"小浪底镇","410322107":"麻屯镇","410322108":"横水镇","410322109":"常袋镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410322.json
// module id = 1417
// module chunks = 0